import React from 'react';
import './Top_Page.css';
import Header from '../components/header';
import News from '../components/news';
import SNS from '../components/sns';
import PlayerCounter from '../components/PlayerCounter'; // PlayerCounterコンポーネントをインポート
import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';
import largeImage_mobile from '../images/top_page_mobile.jpg';
import largeImage from '../images/top_page.jpg';
import MySlider from '../components/MySlider';
import Footer from '../components/Footer'; // Footerコンポーネントをインポート
import { isMobile } from 'react-device-detect'; // デバイスタイプの検出
import ParticipantBox from './ParticipantBox';


const participantCount = 12; // 例として参加者数を設定、動的にデータを取得する場合はここを変更

const TopPagePC = () => {
  return (
    <div className="page">
      <Header />
      <main className="main relative">
        <div className="relative">
          <img 
            src={largeImage} 
            alt="Image 2" 
            className="w-full h-auto object-cover" 
          />
        </div>
        <br></br>
        <ParticipantBox count={participantCount} /> {/* ParticipantBoxをNewsの上に追加 */}
        <br />
        <MySlider />
        <News />
        <SNS />
        <br></br>        
        <br></br>
        <br></br>        
      </main>
      <Footer /> 
    </div>
  );
}

const TopPageMobile = () => {

  return (
    <div className="page">
      <Header />
      <main className="main relative">
        <div className="relative">
        <img 
          src={largeImage_mobile} 
          alt="Image 2" 
          className="w-full h-[350px] object-cover" 
        />
          {/* <PlayerCounter /> PlayerCounterコンポーネントを画像の上に重ねて表示 */}
        </div>
        <br />
        <ParticipantBox count={participantCount} /> {/* ParticipantBoxをNewsの上に追加 */}
        <br />
        <MySlider />
        <News />
        <SNS />       
      </main>
      <Footer /> 
    </div>
  );
}

function TopPage() {
  return isMobile ? <TopPageMobile /> : <TopPagePC />;
}

export default TopPage;
